import * as actions from './redux/actions';

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import KuposDatePicker from './KuposDatePicker';
import KuposSelectBox from './KuposSelectBox';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

class NewSearchBox extends Component {
  static propTypes = {
    cities: PropTypes.array,
    openNewSearch: PropTypes.bool,
    pbSourceCity: PropTypes.object,
    sourceCityOnChange: PropTypes.func,
    destinationCityOnChange: PropTypes.func,
    onwardPBDate: PropTypes.string,
    onwardDateChange: PropTypes.func,
    returnPBDate: PropTypes.string,
    returnDateChange: PropTypes.func,
    swapCities: PropTypes.func,
    newSearch: PropTypes.func,
    t: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      filteredCities: this.props.cities,
    };
    this.destinationRef = React.createRef();
  }

  componentDidMount() {
    // console.log('this.props.citie', this.props.cities);
    this.setState({ filteredCities: this.props.cities });
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log(
    //   '=================',
    //   prevProps,
    //   prevState,
    //   (this.props.cities || []).filter(
    //     it => this.props.pbSourceCity && this.props.pbSourceCity.value !== it.value,
    //   ),
    // );
    // console.log(prevProps.pbSourceCity, this.props.pbSourceCity)
    if (
      (prevProps.cities || []).length !== (this.props.cities || []).length ||
      (prevProps.pbSourceCity &&
        this.props.pbSourceCity &&
        prevProps.pbSourceCity.value !== this.props.pbSourceCity.value)
    ) {
      this.setState({ key: this.state.key + 1 });
    }
  }

  getDestinationOptions = () => {
    return (this.props.cities || []).filter(
      it => this.props.home.pbSourceCity && this.props.home.pbSourceCity.value !== it.value,
    );
  };

  swapCities = () => {
    this.props.swapCities();
    this.setState({ key: this.state.key + 1 });
  };
  getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    // console.log('destinations and item', rawArray, itemToRemove);

    if (rawArray && itemToRemove) {
      return rawArray
        .map(function(obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function(obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };

  sourceChange = val => {
    this.props.sourceCityOnChange(val);
    // this.props.destinationCityOnChange(null);
    // console.log("DFFFFFGHGFGFHG", this.props.pbSourceCity)

    console.log('val', val);
    this.setState({
      filteredCities: this.getOriginSelectedFilteredDestinations(
        this.state.filteredCities,
        this.props.pbSourceCity,
      ),
    });
    // if (this.props.home.pbSourceCity && !this.props.home.pbDestinationCity || !this.props.home.pbSourceCity && !this.props.home.pbDestinationCity) {
    //   // this.destinationRef.current.onMenuOpen()
    // }

    if (
      this.props.home.pbDestinationCity &&
      val.value === this.props.home.pbDestinationCity.value
    ) {
      console.log('check');
      // set The destination input to null
      // this.destinationRef.current.onMenuOpen()
      this.props.destinationCityOnChange(null);
    }
    this.destinationRef.current.select.focus();
    this.destinationRef.current.onMenuOpen();
  };

  render() {
    const { t } = this.props;
    const operator = CommonService.getLocal('op') || {};

    console.log('Props in new searchg box00000000000000', this.props);
    return (
      <div
        className={'common-new-search-box ' + (this.props.openNewSearch ? 'open' : '')}
        style={{ backgroundColor: this.props.backgroundColor }}
      >
        <div className={' content-container new-search-box home-selection-input-boxes '}>
          <div className="home-selection-input-box font10">
            <span className="label font10">{t('HOME.ORIGIN')}</span>
            <KuposSelectBox
              reactSelect
              appType={CommonService.isTrain() ? 'train' : ''}
              selectType="origin"
              options={this.props.cities}
              selectedOption={this.props.home.pbSourceCity}
              onChange={val => this.sourceChange(val)}
              placeholder={'Source'}
              hideArrow={true}
              icon={getIcons('Origin', operator)}
              height={40}
              key={(this.props.home.pbSourceCity || {}).value}
              t={t}
            />
            {/* <div className="home-selection-input kupos-border">
                <img className="icon-size" src="./static/images/icons/home/icon_source.png"/> <span>Source</span>
            </div> */}
          </div>
          <div className="home-selection-input-box swap-icon">
            <img src="/static/images/icons/icon-swap.png" onClick={this.swapCities} />
          </div>

          <div className="home-selection-input-box font10 ">
            <span className="label font10">{t('HOME.DESTINATION')}</span>
            <KuposSelectBox
              reactSelect
              appType={CommonService.isTrain() ? 'train' : ''}
              selectType="destination"
              selectRef={this.destinationRef}
              // options={this.state.filteredCities}
              // options={this.props.cities}
              options={
                this.props.pbSourceCity
                  ? this.getOriginSelectedFilteredDestinations(
                      this.props.cities,
                      this.props.pbSourceCity,
                    )
                  : []
              }
              selectedOption={this.props.home.pbDestinationCity}
              onChange={this.props.destinationCityOnChange}
              placeholder={'Destination'}
              hideArrow={true}
              icon={getIcons('Destination', operator)}
              height={40}
              key={(this.props.home.pbDestinationCity || {}).value}
              t={t}
            />
            {/* <div className="home-selection-input kupos-border">
                <img className="icon-size" src="./static/images/icons/home/icon_source2.png"/> <span>Source</span>
            </div> */}
          </div>

          <div className="home-selection-input-box datebox font10">
            <span className="label font10">{t('HOME.ONE_WAY')}</span>
            <KuposDatePicker
              minDate={DateService.getTodayString()}
              selectedDate={this.props.onwardPBDate}
              onDateChange={date => {
                this.props.onwardDateChange(date);
                date > this.props.returnPBDate ? this.props.returnDateChange(date) : null;
              }}
            />
            {/* <div className="home-selection-input kupos-border">
                  <img className="icon-size" src="./static/images/icons/home/icon_calendar.png"/> <span>Source</span>
              </div> */}
          </div>
          {this.props.home && !this.props.home.is_mot && (
            <div className="home-selection-input-box datebox font10">
              <span className="label font10">{t('HOME.ROUND_TRIP')}</span>
              <KuposDatePicker
                minDate={this.props.onwardPBDate}
                selectedDate={this.props.returnPBDate}
                onDateChange={date => this.props.returnDateChange(date)}
                placeholder={t('HOME.OPTIONAL_DATE')}
              />
              {/* <div className="home-selection-input kupos-border">
                    <img className="icon-size" src="./static/images/icons/home/icon_calendar.png"/> <span>Source</span>
                </div> */}
              {this.props.returnPBDate && (
                <img
                  className="pointer"
                  onClick={() => this.props.returnDateChange('')}
                  src={'/static/images/icons/cross.png'}
                  style={{
                    width: 12,
                    height: 12,
                    resizeMode: 'contain',
                    position: 'absolute',
                    right: 7,
                    bottom: 18,
                  }}
                  alt=""
                />
              )}
            </div>
          )}

          <div className="home-selection-input-box datebox font10">
          <button
              className="kupos-button home-selection-input-button "
              onClick={this.props.newSearch}
              style={{
                background:
                  operator && operator.color_codes && operator.color_codes.button_color
                    ? operator.color_codes.button_color
                    : '',
                color: operator && operator.operator_name === 'combarbala' ? '#000' : operator.operator_name === 'busnorte'
                ? operator.color_codes.header_color: "",
              }}
            >
              <img
                className="icon-size"
                src={getIcons('Search', operator)}
                // alt={this.props.t('TRANSLATIONS.ICON_SEARCH_WHITE')}
                alt=""
              />
              <span className="font11">{t('HOME.SEARCH')}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(NewSearchBox));



// WEBPACK FOOTER //
// ./src/features/common/NewSearchBox.js